import { useCallback, useState } from 'react';

export interface UseDialogReturn {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export function useDialog(initialOpen = false): UseDialogReturn {
  const [open, setOpen] = useState(initialOpen);

  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    open,
    onOpen,
    onClose,
  };
}
